import { createGlobalStyle } from 'styled-components';

export const ThemeGlobalStyle = createGlobalStyle`
  // Personalizzazione pulsanti
  .ant-btn {

    // tutti i pulsanti 
    font-weight: 600;

    // pulsante default
    &.ant-btn-default {

      /* &:not(:disabled):not(.ant-btn-disabled){
        &:hover {
          border-color: ${props => props.theme.colorPrimary};
          background-color: #f0f0f0;
          color:  ${props => props.theme.colorPrimary};
        }
      } */
    }
    // pulsante primario
    /* &.ant-btn-primary {

      &:not(:disabled):not(.ant-btn-disabled){
        &:hover {
          border-color: ${props => props.theme.orangeButtonRer};
          background-color: #fff;
          color:  ${props => props.theme.colorPrimary};
        }
      }
    } */
  }

  
  `;
